// extracted by mini-css-extract-plugin
export var animationContainer = "_k2-0";
export var footer = "_k2-1";
export var gray = "_k2-2";
export var lineItem = "_k2-3";
export var lineItemImage = "_k2-4";
export var lineItemInfo = "_k2-5";
export var lineItemText = "_k2-6";
export var lineItems = "_k2-7";
export var modalContent = "_k2-8";
export var options = "_k2-9";
export var orderName = "_k2-a";
export var refundAmount = "_k2-b";